import { useMutation } from 'react-query';
import queries from '../queries';

/**
 * Hook to register account with company selection
 * Supports either existing company (companyId) or new company (pendingCompany)
 */
const useRegisterAccount = (callbacks = {}) => {
  return useMutation(
    (data) => queries.enterprise.registerWithCompany.query(data),
    {
      ...callbacks,
      onSuccess: ({ data }, variables) => {
        if (typeof callbacks.onSuccess === 'function') callbacks.onSuccess(data, variables);
      },
    }
  );
};

export default {
  useRegisterAccount,
};
